<div class="comp-people px-1 py-3 no-photos">
    <div class="h-100 d-flex justify-content-between flex-column text-center">
        <h6 class="position">{{ dataPeople?.position }}</h6>
        <h6 class="name mt-4 mb-0">{{ dataPeople?.fullname }}</h6>
    </div>
</div>
